import * as XLSX from 'xlsx';

const fmt = (ts) => {
  if (!ts) return '';
  try {
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleString('en-GB', { day:'2-digit', month:'2-digit', year:'numeric', hour:'2-digit', minute:'2-digit' });
  } catch { return ''; }
};

export function exportToExcel({ incidents = [], patrols = [], officers = [], users = [], dailyLogs = [] }) {
  const wb = XLSX.utils.book_new();

  const incRows = incidents.map(i => ({
    'Incident ID':  i.id || i.incident_id || '',
    'Site':         i.siteName || '',
    'Category':     i.category || '',
    'Escalation':   i.escalationLevel || '',
    'Status':       i.status || '',
    'Officer':      i.guardName || '',
    'Description':  i.description || '',
    'Action Taken': i.action_taken || '',
    'Date/Time':    fmt(i.createdAt),
  }));
  const wsInc = XLSX.utils.json_to_sheet(incRows.length ? incRows : [{'No Data':'No incidents found'}]);
  wsInc['!cols'] = Array(9).fill({ wch: 22 });
  XLSX.utils.book_append_sheet(wb, wsInc, 'Incidents');

  const patRows = patrols.map(p => ({
    'Route':          p.route_name || '',
    'Site':           p.site || '',
    'Officer':        p.officer_email || '',
    'Points Checked': p.points_checked || 0,
    'Points Total':   p.points_total || 0,
    'Completed':      p.completed ? 'Yes' : 'No',
    'Completed At':   fmt(p.completed_at),
  }));
  const wsPat = XLSX.utils.json_to_sheet(patRows.length ? patRows : [{'No Data':'No patrols found'}]);
  wsPat['!cols'] = Array(7).fill({ wch: 22 });
  XLSX.utils.book_append_sheet(wb, wsPat, 'Patrols');

  const offRows = officers.map(o => ({
    'Email':       o.guardEmail || '',
    'Status':      o.active ? 'On Shift' : 'Off Shift',
    'Checked In':  fmt(o.checkedInAt),
    'Checked Out': fmt(o.checkedOutAt),
    'Updated':     fmt(o.updatedAt),
  }));
  const wsOff = XLSX.utils.json_to_sheet(offRows.length ? offRows : [{'No Data':'No officers on shift'}]);
  wsOff['!cols'] = Array(5).fill({ wch: 24 });
  XLSX.utils.book_append_sheet(wb, wsOff, 'Officers');

  const teamRows = users.map(u => ({
    'Name':       u.name || u.displayName || '',
    'Email':      u.email || '',
    'Role':       u.role || '',
    'SIA Number': u.sia_number || '',
    'Phone':      u.phone || '',
    'Active':     u.active ? 'Yes' : 'No',
    'Tenant':     u.tenant_id || '',
  }));
  const wsTeam = XLSX.utils.json_to_sheet(teamRows.length ? teamRows : [{'No Data':'No users found'}]);
  wsTeam['!cols'] = Array(7).fill({ wch: 24 });
  XLSX.utils.book_append_sheet(wb, wsTeam, 'Team');

  const logRows = dailyLogs.map(l => ({
    'Date':        l.log_date || '',
    'Site':        l.site_location || '',
    'Officer':     l.officer_name || l.officer_email || '',
    'Shift Start': l.shift_start || '',
    'Shift End':   l.shift_end || '',
    'Checks Done': l.checks_completed || 0,
    'Occurrence':  l.occurrence_type || '',
    'Notes':       l.notes || '',
  }));
  const wsLog = XLSX.utils.json_to_sheet(logRows.length ? logRows : [{'No Data':'No logs found'}]);
  wsLog['!cols'] = Array(8).fill({ wch: 22 });
  XLSX.utils.book_append_sheet(wb, wsLog, 'Daily Logs');

  const now = new Date().toLocaleString('en-GB');
  const summaryRows = [
    {'oSecurity Report':'Exported at','Value':now},
    {'oSecurity Report':'Total Incidents','Value':incidents.length},
    {'oSecurity Report':'Open Incidents','Value':incidents.filter(i=>i.status==='open').length},
    {'oSecurity Report':'Critical','Value':incidents.filter(i=>(i.escalationLevel||'').includes('3')||(i.escalationLevel||'').includes('Emergency')).length},
    {'oSecurity Report':'Total Patrols','Value':patrols.length},
    {'oSecurity Report':'Completed Patrols','Value':patrols.filter(p=>p.completed).length},
    {'oSecurity Report':'Officers on Shift','Value':officers.length},
    {'oSecurity Report':'Team Members','Value':users.length},
    {'oSecurity Report':'Daily Logs','Value':dailyLogs.length},
  ];
  const wsSum = XLSX.utils.json_to_sheet(summaryRows);
  wsSum['!cols'] = [{ wch: 30 }, { wch: 20 }];
  XLSX.utils.book_append_sheet(wb, wsSum, 'Summary');

  const date = new Date().toISOString().split('T')[0];
  XLSX.writeFile(wb, 'oSecurity-Export-' + date + '.xlsx');
}
